export enum ErrorMessages {
  SORRY_SOMETHING_WENT_WRONG = 'Sorry, something went wrong',
  CONTACT_ADMIN = 'Please contact the system administrator',
  ERROR_EDIT_CHANNELS = 'Could not edit channel',
  ERROR_ADD_CHANNELS = 'Could not add channel to brand',
}
